export const toastPlacementData = [
    {
       class:"top-0 start-0",
       title:"Top left" 
    },
    {
        class:"top-0 start-50 translate-middle-x",
        title:"Top center" 
     },
     {
        class:"top-0 end-0",
        title:"Top right" 
     },
     {
        class:"top-50 start-0 translate-middle-y",
        title:"Middle left" 
     },
     {
        class:"top-50 start-50 translate-middle",
        title:"Middle center" 
     },
     {
        class:"top-50 end-0 translate-middle-y",
        title:"Middle right" 
     },
     {
        class:"bottom-0 start-0",
        title:"Bottom left" 
     },
     {
        class:"bottom-0 start-50 translate-middle-x",
        title:"Bottom center" 
     },
     {
        class:"bottom-0 end-0",
        title:"Bottom right" 
     }
]